/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, inject} from '@angular/core';
import template from './layout-include-edit-page.component.html';
import {SignalAdminResourceEditPageBase} from '../../common/controller/signal-admin-resource-edit-page-base';
import {SignalAdminResourceListState, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {
  LayoutIncludeApiService,
  LayoutIncludeModel,
  LayoutUsageApiService,
  LayoutUsageModel
} from './layout-include-api.service';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {CodemirrorFieldComponent} from '../../common/directives/codemirror-field.component';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, FormsModule, TranslateModule, UIRouterModule, CodemirrorFieldComponent, FormControlsModule, SignalAdminResourceListComponent],
  selector: 'adn-layout-include-edit-page',
  template
})
export class LayoutIncludeEditPageComponent extends SignalAdminResourceEditPageBase<LayoutIncludeModel> {
  showLayoutDetail = false;
  usageList: SignalAdminResourceListState<LayoutUsageModel> | null = null;
  readonly usageColumns = [
    {param: 'name'},
    {param: 'description'},
    {param: 'layoutType'},
    {param: 'layoutCategory'}
  ];

  private readonly listFactory = inject(SignalAdminResourceListStateFactory);
  private readonly layoutUsageApi = inject(LayoutUsageApiService);
  private readonly componentDestroyRef = inject(DestroyRef);

  constructor(
    api: LayoutIncludeApiService
  ) {
    super(api, 'layoutInclude');
  }

  protected override initialiseModel(model: LayoutIncludeModel): LayoutIncludeModel {
    const initialised = super.initialiseModel(model);
    if (!this.usageList) {
      this.usageList = this.listFactory.create(
        this.layoutUsageApi,
        {
          listId: 'layoutsUsingLayoutInclude',
          additionalParams: {layoutInclude: initialised.id}
        },
        this.componentDestroyRef
      );
      this.usageList.readOnly.set(true);
      if (!this.isNew) {
        this.usageList.load();
      }
    }
    return initialised;
  }

  protected override afterSave(): void {
    this.usageList?.load();
  }
}
